import React from 'react';

import { FormattedMessage } from 'react-intl';

import { identifiersMessages } from 'src/features/membership/utils/messages';
import SquareIcon from 'src/registry/components/blocks/SquareIcon';
import { Button } from 'src/registry/ui/Button';
import {
    Dialog,
    DialogBody,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogSeparator,
    DialogTitle,
} from 'src/registry/ui/Dialog';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';

type WaiveObligationsModalProps = {
    handleConfirm: (value: boolean) => void;
    isConfirmOpen: boolean;
    setIsConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const WaiveObligationsModal = ({ handleConfirm, isConfirmOpen, setIsConfirmOpen }: WaiveObligationsModalProps) => {
    return (
        <Dialog modal open={isConfirmOpen} onOpenChange={setIsConfirmOpen}>
            <DialogContent>
                <DialogHeader className="flex-row gap-2">
                    <SquareIcon icon={ICON_MAP.QUESTION} />
                    <div>
                        <DialogTitle>
                            <FormattedMessage {...identifiersMessages.waiveObligationsTitle} />
                        </DialogTitle>
                        <DialogDescription>
                            <FormattedMessage {...identifiersMessages.waiveObligationsSubtitle} />
                        </DialogDescription>
                    </div>
                </DialogHeader>
                <DialogSeparator />
                <DialogBody>
                    <p className="text-gray-500">
                        <FormattedMessage {...identifiersMessages.waiveObligationsConfirmation} />
                    </p>
                </DialogBody>
                <DialogSeparator />
                <DialogFooter>
                    <Button variant="outline" type="button" className="flex-1" onClick={() => handleConfirm(false)}>
                        <FormattedMessage {...generalMessages.no} />
                    </Button>
                    <Button variant="default" type="button" className="flex-1" onClick={() => handleConfirm(true)}>
                        <FormattedMessage {...generalMessages.yes} />
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default WaiveObligationsModal;
